export default {
  myButton: {
    color: 'green',
  },
  bg: {
    background: '#f00',
  },
}
